import React from 'react';
import ReactTooltip from 'react-tooltip';
import './ARMFloorTooltip.scss';
import ARMFloorTooltipContent from './ARMFloorTooltipContent';

export default function ARMFloorTooltip(props) {
  const {id, metric, benchmarkName, firstName} = props;

  if(metric !== "ARM") return null;
  if(!benchmarkName) return null;

  const tooltipText = ARMFloorTooltipContent({firstName});
  return (
    <ReactTooltip id={id} className="arm-floor-tooltip" place="top" effect="solid">
      {tooltipText}
    </ReactTooltip>
  );
}